import { cn } from '@april9au/react-common/utils';

/** Single-number credential card — e.g. "26 YEARS of real estate experience." Pairs with `AppraisalCard` in a hero's card stack. */
export function StatCard({
  value,
  label,
  description,
  className,
}: {
  value: string;
  label: string;
  description: string;
  className?: string;
}) {
  return (
    <div className={cn('card', className)}>
      <div className="flex items-baseline gap-2.5">
        <span className="text-5xl font-light text-gold">{value}</span>
        <span className="text-eyebrow">{label}</span>
      </div>
      <p className="text-body mt-3.5">{description}</p>
    </div>
  );
}
